// Server API for projects and workflows.
import axiosAPI from "../config/axiosInstance";

// ---------- Projects ----------
export const getAccessibleProjects = () => axiosAPI("get", "projects");
export const getProjectsData = () => axiosAPI("get", "allProjects");
export const addNewProject = (projectName) => axiosAPI("post", "projects", { projectName });
export const deleteProjectById = (id) => axiosAPI("delete", `projects/${id}`);

// ---------- Workflows ----------
export const getProjectWorkflows = (projectId) => axiosAPI("get", `projects/${projectId}/workflows`);
export const getSharedWorkflows = () => axiosAPI("get", "workflows/shared");
export const getWorkflow = (id) => axiosAPI("get", `workflows/${id}`);
export const createWorkflow = (workflow) => axiosAPI("post", "workflows", workflow);
export const updateWorkflow = (id, changes) => axiosAPI("put", `workflows/${id}`, changes);
export const deleteWorkflow = (id) => axiosAPI("delete", `workflows/${id}`);
export const getWorkflowVersions = (id) => axiosAPI("get", `workflows/${id}/versions`);
export const getWorkflowVersion = (id, version) => axiosAPI("get", `workflows/${id}/versions/${version}`);
export const restoreWorkflowVersion = (id, version) => axiosAPI("post", `workflows/${id}/versions/${version}/restore`);
export const countWorkflowRun = () => axiosAPI("post", "workflows/execution-count");
